import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { GroupUsersEditCard } from "./edit_card";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

export const GroupUsersCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <GroupUsersEditCard
          id={id}
          client={Clients.ADMIN_QUANTILIA}
          table_name={Tables.GROUP_USERS}
        />
        <AuditCard
          id={id}
          client={Clients.ADMIN_QUANTILIA}
          audit_table_name={Tables.GROUP_USERS}
        />
      </div>
    </div>
  );
};
